import styles from "./Contact.module.scss";
import { ContactForm } from "../ContactForm/ContactForm";
export const Contact = () => {
  const {
    section__contact,
    wrapper__contact,
    contact__title,
    contact,
    contact__leftSide,
    contact__paragraf,
    contact__rightSide,
  } = styles;

  return (
    <section className={section__contact} id="contact">
      <div className={wrapper__contact}>
        <h2
          className={contact__title}
          data-aos="fade-right"
          data-aos-delay="200"
        >
          Zamów bezpłatną wycenę
        </h2>
        <div className={contact}>
          <div className={contact__leftSide}>
            <p
              className={contact__paragraf}
              data-aos="fade-up"
              data-aos-delay="200"
            >
              Profesjonalna witryna stworzona przez specjalistów z pewnością
              przyniesie lepsze efekty.
            </p>
            <p
              className={contact__paragraf}
              data-aos="fade-up"
              data-aos-delay="300"
            >
              Jeśli nie wiesz, od czego zacząć, jestem tutaj, by Ci pomóc!
            </p>
            <p
              className={contact__paragraf}
              data-aos="fade-up"
              data-aos-delay="300"
            >
              Sprawdź, jak łatwo pomogę Ci rozwinąć Twój biznes online!
            </p>
            <p
              className={contact__paragraf}
              data-aos="fade-up"
              data-aos-delay="500"
            >
              Skontaktuj się ze mną!
            </p>
          </div>
          <div className={contact__rightSide}>
            <ContactForm />
          </div>
        </div>
      </div>
    </section>
  );
};
